import React, { FC } from 'react'
import Button, { IUIButtonProps } from './Button'
import cx from 'classnames'
import css from './button.module.scss'

// TODO remove these buttons after adding EVO library
export const EvoButton: FC<IUIButtonProps> = ({ className, ...props }) => {
  return <Button ghost={false} className={cx(css.evo_button, className)} {...props} />
}

export const EvoGhostButton: FC<IUIButtonProps> = ({ className, ...props }) => {
  return (
    <Button
      ghost={false}
      className={cx(css.evo_button, css.evo_button_ghost, className)}
      {...props}
    />
  )
}

export const EvoAttantionButton: FC<IUIButtonProps> = ({ className, ...props }) => {
  return (
    <Button
      ghost={false}
      className={cx(
        css.evo_button,
        css.evo_button_ghost,
        css.evo_button_ghost__attantion,
        className
      )}
      {...props}
    />
  )
}
